import { pushAnalyticsObjToDataLayer } from "@/utils/helper"

export const triggerShowEvnetForPXP = () => {
  if (window?.adobeDataLayer?.length) {
    return
  }
  const page = {
    cart: {
      cartID: "3d03d4ed-3468-40c8-91eb-9a776c35bdc9",
      Item: "<productInfo>",
      price: {
        basePrice: 0,
        cartTotal: 0,
        couponCode: "n/a",
        couponDiscount: 0,
        currency: "usd",
        globalDiscount: 0,
        globalOffer: "n/a",
        orderCouponCode: "n/a",
        orderCouponDiscount: 0,
        priceWithTax: 0,
        shipping: "n/a",
        shippingMethod: "ground",
        taxRate: "n/a",
        voucherCode: "n/a",
        voucherDiscount: 0,
      },
      cartInfo: {
        cartItems:
          "<product sku ids need to be passed based on the existing cart items>",
      },
    },
    category: {
      pageType: "pxp",
      primaryCategory: "kohler:pxp",
      productLocalCategory: "toilets",
      room: "bathroom",
      subCategory1: "pxp:toilets",
      subCategory2: "kohler:pxp:toilets:K-3988-RA-0",
      subCategoryID: "K-3988-RA-0",
      subCategoryID2: "n/a",
      subCategoryName: "toilets",
    },
    pageInfo: {
      contentType: "pxp",
      description:
        "Discover our collection of KOHLER faucets, showers, sinks, toilets, bidets and more. Get design inspiration for your next kitchen or bath project.",
      keywords: "Kohler US Plumbing Bathroom Kitchen",
      language: "en",
      mktgCampaign: "n/a",
      pageName: "kohler:pxp:toilets:3988-RA-0",
      pageUrl:
        "https://www.kohler.com/en/products/toilets/shop-toilets/wellworth-two-piece-elongated-dual-flush-toilet-w-right-hand-trip-lever-3988-ra?skuId=3988-RA-0",
      previousPage: "n/a",
      redirect: "https://www.kohler.com/en/products/bathroom-faucets",
      referrer: "kohler:pxp:toilets:K-3988-RA-0",
      timestamp: "2024-05-08 09:50:29",
      title: "KOHLER x Arsham | Landshapes Collection | KOHLER",
      thumbnailImageUrl:
        "https://kohler.scene7.com/is/image/kohlergbhprod/Thumbnail-Images-aag24570_rgb",
    },
    site: {
      appVersion: "aem 6.5.9",
      environment: "prod",
      geoRegion: "us",
      language: "en",
      orientation: "landscape",
      platform: "desktop",
      responsiveFormat: false,
      siteName: "kohler",
      targetPropertyID: "n/a",
    },
    user: {
      abTestName: "n/a",
      adBlocker: false,
      authStatus: "anonymous",
      commerceToolsID: "n/a",
      customerProspect: "n/a",
      emailId: "n/a",
      envName: "development",
      gId: "12a3697f-e3c9-432e-b6a4-d7e921670a68",
      knownStatus: "unknown",
      profileRole: "guest",
      returningStatus: "new visitor",
    },
    productInfo: {
      category: "toilets",
      defaultImageName: "https://kohler.scene7.com/is/image/PAWEB/zab67994_rgb",
      description: "two-piece elongated toilet dual-flush",
      frequency: "n/a",
      globalDiscount: 0,
      globalOffer: "n/a",
      globalPromotionPrice: 327.94,
      isRecommended: "n/a",
      isSendNow: "n/a",
      isSubscription: "n/a",
      itemType: "product",
      numberOfReviews: "n/a",
      pxpType: "regular w/required Items",
      priceState: "regular price",
      productBasePrice: 327.94,
      productBrand: "kohler",
      productCategory: "toilets",
      productCollectionsName: "wellworth",
      productColor: "white",
      productCouponCode: "n/a",
      productCoupondiscount: 0,
      productFindingMethod: "n/a",
      productID: "K-3988-RA-0",
      productName: "wellworth",
      productPartnerBuyNow: false,
      productRoom: "bathroom",
      productSalePrice: 327.94,
      productSaleable: true,
      productStatus: "in stock",
      productSuperSku: true,
      productTileName: "wellworth",
      quantity: 1,
      ratings: "n/a",
      waterSenseProduct: true,
    },
  }
  pushAnalyticsObjToDataLayer({}, "cmp:show", page)
}

export const triggerClickAnalytics = (eventInfo = {}) => {
  pushAnalyticsObjToDataLayer(eventInfo)
}
